module.exports = __webpack_public_path__ + "img/tiktok.049e3e7e.png";